import { useTranslation } from "react-i18next";

import { Step, StepIcon, Steps, StepText, Title } from "./WhatHappensNextStyles";

export interface IWhatHappensNextProps {
  isFromBasket?: boolean;
  content: Record<string, string>[];
}

const WhatHappensNext = ({ content }: IWhatHappensNextProps) => {
  const { t } = useTranslation();

  return (
    <section data-testid="what-happens-next">
      <Title data-testid="what-happens-next-title">{t("What Happens Next")}</Title>
      <Steps>
        {content.map(({ img, text }, index) => (
          <Step key={index}>
            <StepIcon src={img} alt="step" data-testid={`what-happens-next-image-step-${index + 1}`} />
            <StepText data-testid={`what-happens-next-step${index + 1}`}>{text}</StepText>
          </Step>
        ))}
      </Steps>
    </section>
  );
};

export default WhatHappensNext;
